/**
 * City-skyline hero panel registry -- maps a city key to its exported hero
 * image assets (frontend/public/hero/) and pixel dimensions.
 *
 * Real, licensed photos only (Design Specification.md Section 3.5's
 * ratified exception, scoped to hero photo composites -- see Home.jsx's
 * hero comment block for the full rule). Add a new city only once its
 * photo has actually been sourced, licensing verified, and run through
 * frontend/scripts/hero-images/regrade_city_skyline.py -- never add a key
 * here ahead of having the real files under public/hero/, since every
 * consumer (CitySkylinePanel) assumes a listed city's assets exist.
 *
 * Added 2026-09-24 alongside the Houston "Be Someone" bridge photo, to stop
 * the city panel's image path/dimensions from being hardcoded per page --
 * a planned follow-up page needs the same panel pattern for Dallas, Austin,
 * Fort Worth, San Antonio, and Lubbock. Those are NOT added here yet (no
 * photos sourced for them as of this change) -- do not add placeholder
 * entries pointing at a city's photo that does not exist.
 *
 * Key naming intentionally matches backend/catalog/nearest_city.py's
 * `city_key` values exactly ("houston", "dallas", "austin", "fort_worth",
 * "san_antonio", "lubbock") -- the Plans-page hero task can pass the
 * nearest-city endpoint's city_key straight into <CitySkylinePanel city=.../>
 * with no translation layer, once those five photos exist. city_key=null
 * (ZIP outside the 55-mile radius of all six) is that page's own scope to
 * handle -- this module makes no null/fallback decision.
 */
export const CITY_SKYLINES = {
  houston: {
    base: "city-houston",
    label: "Houston",
    dims: [1199, 1312],
    credit:
      "Owner-supplied photo of the Houston skyline / Be Someone bridge. Original source/license " +
      "unverified -- the Owner, as founder, explicitly approved and overrode this project's " +
      "Design Specification.md Section 3.5 licensed-photography-only rule for this specific image " +
      "on 2026-09-29. Do not treat this as a precedent for any other image on the site without the " +
      "same explicit founder override.",
  },
};

export const DEFAULT_CITY_SKYLINE = "houston";

export function getCitySkyline(city) {
  return CITY_SKYLINES[city] || CITY_SKYLINES[DEFAULT_CITY_SKYLINE];
}
